export default "__VITE_ASSET__3XsCyIKL__"